import { AdminByScheduleParams } from '../administration-schedule/administration-schedule-params';
import { AbortableCloseEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { BaseModalProps, ModalButton, ModalService } from '@philips-internal/oswald-ui-components';
import { ModalButtonType } from '@philips-internal/oswald-ui-constants';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';

export function DialogModalConfirm(event: AbortableCloseEvent, id: string): void {
  const noCardsRead = AdminByScheduleParams.readParam?.noCardsRead;

  if (noCardsRead) {
    ModalService.close(id);
    ModalService.close('dialog-modal-service');
    return;
  }

  event.abort();

  const buttons: ModalButton[] = [];

  buttons.push({
    action: () => { },
    title: 'tws.biometry.cancel',
    type: ModalButtonType.CANCEL,
  });

  buttons.push({
    action: () => redirectToTimeline(id),
    title: 'tws.file-uploader-modal.confirm',
    type: ModalButtonType.SUCCESS,
  });

  const dialogModal: BaseModalProps = {
    dialogDescription: MessageService.translate('text.reset items-want-to-continue'),
    dockButtons: buttons,
    focusOnOpen: true,
    id: 'dialog-modal-service',
    title: 'text.message-alert-attention',
  };

  ModalService.openDialog(dialogModal);
}

export function redirectToTimeline(id: string): void {
  ModalService.close(id);
  ModalService.close('dialog-modal-service');
}